import React from 'react';
import {
  Navigation,
  NavigationContainer,
  NavigationItem,
  NavigationItemsContainer,
  NavigationLineSeparator,
  NavigationSubscriptionButton
} from './UbisoftPlusNavigationStyle';
import { ReactComponent as UbisoftPlusLogo } from '../../assets/ubisoft_plus_logo.svg';
import { withContent } from '../../hoc/withContext';
import { IContent } from '../../types';
import SubscriptionButton from '../SubscriptionButton/SubscriptionButton';
import { useSelector } from 'react-redux';
import { IProductsState } from '../../types/store/reducer';
import { getNavigationPageLink } from '../../utils';

interface INavigationProps {
  context?: IContent;
}

interface Products {
  products : IProductsState
}

const UbisoftPlusNavigation = ({ context }: INavigationProps) => {
  let countryCode = useSelector(({ products } : Products) => products.countryCode);

  return (
    <Navigation>
      <NavigationContainer>
        <UbisoftPlusLogo className={'navigation-logo'} />
        <NavigationLineSeparator />
        <NavigationItemsContainer>
          {Object.keys(context.navigation).map((item: string) =>
            <NavigationItem key={`nav-${item}`} href={getNavigationPageLink(countryCode,item)} isCurrentPage={item === 'landing'}
            >{context.navigation[item]}</NavigationItem>
          )}
        </NavigationItemsContainer>
        <NavigationSubscriptionButton>
          <SubscriptionButton idToAttach={'navigationSubscription'} />
        </NavigationSubscriptionButton>
      </NavigationContainer>
    </Navigation>
  );
};

export default withContent(UbisoftPlusNavigation);